import {TableCell} from "@hosttools/frontend/components";

export default TableCell;
